module.exports = __webpack_public_path__ + "toBride2-jp-r-n.6ab8f3fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-jp-r-n.jpg
// module id = LpB8
// module chunks = 0